@import "../../styles/colors";
@import "../../styles/typography";

.root {
  background-color: $tan;
  overflow: hidden;
}

.section {
  height: 100vh;
}

:global {
  body {
    margin: 0;
    font-family: "MigraExtraLight";
    color: #242528;
    font-size: 12px;
    font-weight: 300;
    overflow-x: hidden;
    user-select: none;
  }

  .header {
    font-family: "MigraExtraBold";
    text-transform: uppercase;
    font-size: 56vmin;
    font-weight: 700;
    letter-spacing: 0.3em;
    color: $text;
  }

  .header2 {
    -webkit-text-stroke-width: 3px !important;
    -webkit-text-stroke-color: black;
    font-family: "MigraExtraBold";
    text-transform: uppercase;
    font-size: 15em;
    font-weight: 700;
    letter-spacing: 0.03em;
    color: transparent;
  }

  .header3 {
    font-family: "MigraExtraBold";
    text-transform: none;
    font-size: 14vmin;
    font-weight: 700;
    letter-spacing: 0.03em;
    color: $text;
  }

  .header4 {
    font-family: "MigraExtraBold";
    text-transform: none;
    font-size: 6vmin;
    font-weight: 700;
    letter-spacing: 0em;
    color: $text;
  }

  .header5 {
    font-family: "IBMPlexMonoRegular";
    text-transform: none;
    font-size: 1em;
    letter-spacing: 0.1em;
    color: $text;
  }

  .header6 {
    font-family: "MigraExtralightItalic";
    text-transform: none;
    font-size: 8vmin;
    font-weight: 700;
    letter-spacing: 0em;
    color: $text;
  }

  .font-weight-light {
    font-family: "MigraExtralight";
    letter-spacing: 0.03em;
    text-transform: none;
  }

  .font-weight-bold {
    font-family: "MigraExtraBold";
    letter-spacing: 0.03em;
    text-transform: none;
  }

  code {
    display: inline-block;
    margin: 0 0.4em 0 0;
    font-family: "MigraExtraLight";
    background-color: lighten($plum, 10%);
    padding: 0.2em 0.4em;
    border-radius: 3px;
  }

  p {
    margin: 2em 0;
    font-size: 1.2em;
    line-height: 1.6;
    color: darken($text, 15%);
  }

  * {
    box-sizing: border-box;
  }

  a {
    color: $text;
    text-decoration: none;
    font-weight: bold;
    &:hover {
      color: $purple;
    }
  }

  hr {
    width: 100%;
    height: 3em;
    background-color: $tan;
    border: none;
  }

  .btn {
    display: inline-block;
    border: 2px solid $purple;
    padding: 0.6em 1em;
    color: $purple;
    font-weight: 500;
    margin-right: 1em;

    &:hover {
      background-color: $purple;
      color: $tan;
    }
  }

  .visually-hidden {
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    overflow: hidden;
  }
}
